import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  decrementQuantity,
  deleteItem,
  incrementQuantity,
} from "../../../redux/cart/actions";
import {
  decrementProductQuantity,
  incrementProductQuantity,
  restoreProductQuantity,
} from "../../../redux/productItems/actions";

export default function ({ item }) {
  const { id, quantity } = item;
  const dispatch = useDispatch();
  const product = useSelector((state) => state.productItems.products);

  const incrementHandler = () => {
    if (product[id].quantity > 0) {
      dispatch(incrementQuantity(id));
    }
    dispatch(decrementProductQuantity(id));
  };

  const decrementHandler = () => {
    dispatch(decrementQuantity(id));
    dispatch(incrementProductQuantity(id));
  };

  const deleteHandler = () => {
    dispatch(deleteItem(id));
    dispatch(restoreProductQuantity(id, quantity));
  };

  return (
    <div>
      {/* <!-- Cart Item --> */}
      <div className="cartCard">
        <div className="flex items-center col-span-6 space-x-6">
          {/* <!-- cart image --> */}
          <img
            className="lws-cartImage"
            src={product[id].imageUrl}
            alt="product"
          />
          {/* <!-- cart item info --> */}
          <div className="space-y-2">
            <h4 className="lws-cartName">{product[id].productName}</h4>
            <p className="lws-cartCategory">{product[id].category}</p>
            <p>
              BDT <span className="lws-cartPrice">{product[id].price}</span>
            </p>
          </div>
        </div>
        <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
          {/* <!-- amount buttons --> */}
          <div className="flex items-center space-x-4">
            <button
              className="lws-incrementQuantity"
              onClick={incrementHandler}
            >
              <i className="text-lg fa-solid fa-plus"></i>
            </button>
            <span className="lws-cartQuantity">{quantity}</span>
            <button
              className="lws-decrementQuantity"
              onClick={decrementHandler}
            >
              <i className="text-lg fa-solid fa-minus"></i>
            </button>
          </div>
          {/* <!-- price --> */}
          <p className="text-lg font-bold">
            BDT{" "}
            <span className="lws-calculatedPrice">
              {product[id].price * quantity}
            </span>
          </p>
        </div>
        {/* <!-- delete button --> */}
        <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
          <button className="lws-removeFromCart" onClick={deleteHandler}>
            <i className="text-lg text-red-400 fa-solid fa-trash"></i>
          </button>
        </div>
      </div>
      {/* <!-- Cart Items Ends --> */}
    </div>
  );
}
